import { CommonAccountDetails, CommonAccountState } from '@provider-portal/common/services/types';
import jwtDecode from 'jwt-decode';

import { GlobalAppState } from 'rdx/state';
import { ErrorReporter } from '@provider-portal/common/utils/errorReporting';

export function commonAccountAdapter(globalState: GlobalAppState): CommonAccountState {
  const accountDetails: CommonAccountDetails | null = globalState.account?.details
    ? {
        account_data: globalState.account.details.account_info.account_data,
        assignments: globalState.account.details.account_info.assignments,
        assignedProvidersByVendor:
          globalState.account.details.account_info.assignedProvidersByVendor,
      }
    : null;

  let vendorPermissions;
  const { accessToken } = globalState.session;
  if (accessToken) {
    try {
      const accountInfo = jwtDecode(accessToken) as
        | undefined
        | { data?: { vendor_permissions: { vendor_id: number }[] } };
      vendorPermissions = accountInfo?.data?.vendor_permissions.map(
        (vendorPermission) => vendorPermission.vendor_id,
      );
    } catch (e) {
      ErrorReporter.captureException(e);
    }
  }

  return {
    details: accountDetails,
    requestState: globalState.account?.requestState,
    selectedProvider: globalState.account?.selectedProvider,
    selectedVendor: globalState.account?.selectedVendor,
    vendorPermissions,
  };
}
